export enum LpUrlParams {
    MONTHS = 'a',
    CODE = 'code',
    CITY_OR_COUNTRY_SLUG = 'cityOrCountrySlug',
    COMPANY_SLUG = 'customSlug',
}

export type ILpUrlProperties = {
    a?: string
    code?: string
    cityOrCountrySlug: string | null
    customSlug: string[] // its an optional catch all route
}

export class LpRoute {
    static createUrl = (params: ILpUrlProperties, citySlugType: 'url-param' | 'search-param') => {
        const searchParams = new URLSearchParams()

        if (params.a) searchParams.append(LpUrlParams.MONTHS, params.a)
        if (params.code) searchParams.append(LpUrlParams.CODE, params.code)

        const pathStart = '/lp/monate-universal'

        if (!params.cityOrCountrySlug) return pathStart

        switch (citySlugType) {
            case 'url-param':
                const basePath = `${pathStart}/${params.cityOrCountrySlug}/${params.a}`

                if (searchParams.toString() === '') return basePath

                return `${basePath}?${searchParams.toString()}`

            case 'search-param':
                searchParams.append(LpUrlParams.CITY_OR_COUNTRY_SLUG, params.cityOrCountrySlug)

                return `${pathStart}?${searchParams.toString()}`
        }
    }
}
